// Export review for `#s10` (FEC-M4-06/07). No export/review HTTP contract
// exists yet. Returning `unavailable` keeps the designed chrome from
// inventing checklist totals or downloadable files.
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

export const exportIssueItemSchema = z.object({
  line_item_id: z.string(),
  merchant: z.string(),
  date_label: z.string(),
  amount: z.string(),
  reason: z.string(),
  included: z.boolean(),
});

export const exportReviewResultSchema = z.discriminatedUnion('status', [
  z.object({ status: z.literal('unavailable') }),
  z.object({
    status: z.literal('ready'),
    tax_year: z.number(),
    period_label: z.string(),
    currency: z.string(),
    income: z.string(),
    expense: z.string(),
    net: z.string(),
    item_count: z.number(),
    event_count: z.number(),
    personal_on_business: z.array(exportIssueItemSchema),
    business_on_personal: z.array(exportIssueItemSchema),
    uncategorized_count: z.number().nullable(),
    missing_receipt_count: z.number().nullable(),
  }),
]);
export type ExportReviewResult = z.infer<typeof exportReviewResultSchema>;

export function useExportReview(taxYear: number) {
  return useQuery<ExportReviewResult>({
    queryKey: ['business-export', taxYear],
    queryFn: async () => {
      return { status: 'unavailable' };
    },
  });
}
